const BASE_URL = "/posted-documents";

export default [

  {
    path: `${BASE_URL}/posted-purchase-request`,
    name: "Posted Purchase Request",
    component: () => import("@/pages/payable/purchaseRequest/Posted.vue"),
  },
  {
    path: `${BASE_URL}/posted-purchase-receiving`,
    name: "Posted Purchase Receipt",
    component: () => import("@/pages/payable/purchaseReceiving/Posted.vue"),
  },
  {
    path: `${BASE_URL}/posted-purchase-order`,
    name: "Posted Purchase Order",
    component: () => import("@/pages/payable/purchaseOrder/Posted.vue"),
  },
  {
    path: `${BASE_URL}/posted-purchase-invoicing`,
    name: "Posted Purchase Invoicing",
    component: () => import("@/pages/payable/purchaseInvoice/Posted.vue"),
  },
  {
    path: `${BASE_URL}/posted-purchase-credit-memo`,
    name: "Posted Purchase Credit Memo",
    component: () => import("@/pages/payable/purchaseCreditMemo/Posted.vue"),
  },
  {
    path: `${BASE_URL}/posted-store-requisition`,
    name: "Posted Store Requisition",
    component: () => import("@/pages/store/storeRequisition/Posted.vue"),
  },
  {
    path: `${BASE_URL}/posted-sales-invoice`,
    name: "Posted Sales Invoicing",
    component: () => import("@/pages/receivable/salesInvoice/Posted.vue"),
  },
  {
    path: `${BASE_URL}/posted-sales-credit-memo`,
    name: "Posted Sales Credit Memo",
    component: () => import("@/pages/receivable/salesCreditMemo/Posted.vue"),
  },
];
